import { render } from "./AppHeader.vue?vue&type=template&id=be7c8c4a&scoped=true"
import script from "./AppHeader.vue?vue&type=script&lang=js"
export * from "./AppHeader.vue?vue&type=script&lang=js"

import "./AppHeader.vue?vue&type=style&index=0&id=be7c8c4a&lang=scss&scoped=true"

import exportComponent from "C:\\git\\Source\\Repos\\LDI.ApplicationSupport.ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be7c8c4a"]])

export default __exports__